<template>
    <div>
        <h3>Service Invoice Frequently Asked Questions</h3>
        <template>
            <div>
                <el-row>
                    <el-collapse accordion id="faqAccordion">
                        <el-collapse-item name="1"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">1. General SIMS inquiries: Parts are not loading, can&#39;t log in to SIMS, locked out of SIMS, etc.</span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; Please call 888-848-4408 ext 202 or 298 for assistance.
                                    </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="2"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">2. Can&#39;t find the client&#39;s store location in a claim.</span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>&#11162; Open your claim. Click the &#34;details&#34; button at the top, then click on the &#34;Site Information&#34; heading. </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <span>&#11162; In the &#34;Client Store&#34; field, enter the store number. </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <span>&#11162; A list related to that number will appear. Choose the appropriate client. </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="3"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">3. Who should we call for assistance with claims?</span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; Please call 888-848-4408 ext 202 or 298 or send an email to invoicing@hardt.ca
                                    </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="4"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">4. How to find repair codes.</span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; Open your claim. Click the &#34;Details&#34; button at the top, then click on the &#34;Site Information&#34; heading.
                                    </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; Select the &#34;Click Here to Add Repair Codes&#34; box.
                                    </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; In the repair code box, type a keyword from the work performed, then select the appropriate repair code from the list.
                                    </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="5"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">5. What is the deadline for submitting claims to Hardt?</span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; All claims must be submitted within 30 days of the date completed.
                                    </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="6"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">6. Where to submit an estimate for an equipment repair that exceeds the Do Not Exceed amount?</span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; All estimates must be submitted to costcoestimate@hardt.ca
                                    </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="7"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">
                                    7. Why is my claim in &#34;partial&#34; status?
                                </span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; Partial status means that the claim has been started and not completed. Note: this is only visible to service partners.
                                    </span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; Click on &#34;Dashboard&#34;, click on the pencil beside the partial claim to complete the claim.
                                    </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="8"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">8. How can I reach technical support?</span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; Please call 800-387-6847 ext 2
                                    </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="9"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">9. How to submit claims for installations</span>
                            </template>
                            <el-collapse>
                                <el-collapse-item>
                                    <template slot="title">
                                        <span class="title" style="text-align: left;">USA</span>
                                    </template>
                                    <el-row>
                                        <el-col>
                                            <span>
                                                &#11162; Costco installs and post installs need to be submitted on separate claims.
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col>
                                            <span style="margin-left:10px">
                                                o	Costco installs must be submitted with service coverage Costco non-warranty (for all the units at 1 warehouse).
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col>
                                            <span style="margin-left:10px">
                                                o	Costco post-installs must be submitted with service coverage Installation/Post installs (for all the units at 1 location).
                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                            <el-collapse>
                                <el-collapse-item>
                                    <template slot="title">
                                        <span class="title" style="text-align: left;">CAN</span>
                                    </template>
                                    <el-row>
                                        <el-col>
                                            <span>
                                                &#11162; Costco installs must be billed directly to the store. Do not submit a claim.
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col>
                                            <span>
                                                &#11162; Costco post-installs must be submitted with service coverage Installation/Post-Install.
                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item>
                                    <template slot="title">
                                        <span class="title" style="text-align: left;">Sam&#39;s Club</span>
                                    </template>
                                    <el-row>
                                        <el-col>
                                            <span>
                                                &#11162; Submit 1 claim for the Installation and Post-Install for all units at the same location. The service coverage is Installation/Post-Install.
                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-collapse-item>
                        <el-collapse-item name="10"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">10. Can we submit repairs for multiple ovens at the same location on 1 claim?</span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; No. A separate claim must be submitted for each oven repaired, unless it is for an install.
                                    </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="11"
                                          :loading="loading">
                            <template slot="title">
                                <span class="title" style="text-align: left;">11. How can we request a SIMS Service Partner manual?</span>
                            </template>
                            <el-row>
                                <el-col>
                                    <span>
                                        &#11162; Please email invoicing@hardt.ca
                                    </span>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-row>
            </div>
        </template>
    </div>
</template>
<script>
    import api from "../../masters/servicecompanies/api";
    export default {
        name: "FAQ",

        data()
        {
            return {
                loading: false,
                showPage: this.visible
            };
        },
        watch: {
            visible: function (val)
            {
                this.showPage = val;
            },

        },
        methods: {
            closePage()
            {
                this.showPage = false;
                this.loading = false;
                this.$emit("faqPageClosed", false);
            }
        }
    }
</script>
<style>
    #faqAccordion .title {
        font-size: 18px;
    }
    #faqAccordion span{
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/Faq/components/Faq.vue